import { render } from "./CockpitHeader.vue?vue&type=template&id=5df06b8c&scoped=true"
import script from "./CockpitHeader.vue?vue&type=script&lang=js"
export * from "./CockpitHeader.vue?vue&type=script&lang=js"

import "./CockpitHeader.vue?vue&type=style&index=0&id=5df06b8c&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df06b8c"]])

export default __exports__